import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/features/identity/services/auth.api";

/**
 * No credential storage here — registering doesn't return a session, it
 * triggers an OTP send. `RegisterPage` is responsible for navigating to
 * `/otp-verification` with the email to verify.
 */
export function useRegister() {
  return useMutation({
    mutationFn: authApi.register,
  });
}
